import {BookOpen, CircleHelp, Clock, Lock, Mail, Paperclip} from 'lucide-react';
import {VelaScene, type VelaRule} from '../engine/types';

export const CHAT_FAQ_CARD_ID = 'chat-faq';
export const CHAT_GUIDEBOOKS_CARD_ID = 'chat-guidebooks';

export const chatRules: VelaRule[] = [
  {
    id: 'chat/attachments',
    section: 'goodToKnow',
    scenes: [VelaScene.Chat],
    priority: 20,
    evaluate: (ctx, t) =>
      ctx.isChatAttachmentsEnabled
        ? {
            id: 'chat-attachments',
            icon: <Paperclip />,
            title: t('card.chat_attachments.title'),
            description: t('card.chat_attachments.body'),
          }
        : null,
  },
  {
    id: 'chat/verify-where',
    section: 'goodToKnow',
    scenes: [VelaScene.ChatVerify],
    priority: 20,
    evaluate: (_ctx, t) => ({
      id: 'chat-verify-where',
      icon: <Mail />,
      title: t('card.chat_verify_where.title'),
      description: t('card.chat_verify_where.body'),
    }),
  },
  {
    id: 'chat/verify-missing',
    section: 'goodToKnow',
    scenes: [VelaScene.ChatVerify],
    priority: 10,
    evaluate: (_ctx, t) => ({
      id: 'chat-verify-missing',
      icon: <Clock />,
      title: t('card.chat_verify_missing.title'),
      description: t('card.chat_verify_missing.body'),
    }),
  },
  {
    id: 'chat/verify-newest',
    section: 'goodToKnow',
    scenes: [VelaScene.ChatVerifyError],
    priority: 20,
    evaluate: (_ctx, t) => ({
      id: 'chat-verify-newest',
      icon: <Mail />,
      title: t('card.chat_verify_newest.title'),
      description: t('card.chat_verify_newest.body'),
    }),
  },
  {
    id: 'chat/disabled-guidebook',
    section: 'goodToKnow',
    scenes: [VelaScene.ChatDisabled],
    priority: 20,
    evaluate: (ctx, t) =>
      ctx.hasGuidebooks
        ? {
            id: 'chat-disabled-guidebook',
            icon: <BookOpen />,
            title: t('card.chat_disabled_guidebook.title'),
            description: t('card.chat_disabled_guidebook.body'),
          }
        : null,
  },
  {
    id: 'chat/disabled-reach-host',
    section: 'goodToKnow',
    scenes: [VelaScene.ChatDisabled],
    priority: 10,
    evaluate: (_ctx, t) => ({
      id: 'chat-disabled-reach-host',
      icon: <Mail />,
      title: t('card.chat_disabled_reach_host.title'),
      description: t('card.chat_disabled_reach_host.body'),
    }),
  },
  {
    id: 'chat/faq',
    section: 'quickActions',
    scenes: [
      VelaScene.Chat,
      VelaScene.ChatVerify,
      VelaScene.ChatVerifyError,
      VelaScene.ChatDisabled,
      VelaScene.ChatNotRegistered,
    ],
    priority: 20,
    evaluate: (ctx, t) =>
      ctx.isFaqEnabled
        ? {
            id: CHAT_FAQ_CARD_ID,
            icon: <CircleHelp />,
            title: t('card.chat_faq.title'),
            description: t('card.chat_faq.body'),
          }
        : null,
  },
  {
    id: 'chat/guidebooks',
    section: 'quickActions',
    scenes: [VelaScene.Chat, VelaScene.ChatDisabled, VelaScene.ChatNotRegistered],
    priority: 10,
    evaluate: (ctx, t) =>
      ctx.hasGuidebooks
        ? {
            id: CHAT_GUIDEBOOKS_CARD_ID,
            icon: <BookOpen />,
            title: t('card.chat_guidebooks.title'),
            description: t('card.chat_guidebooks.body'),
          }
        : null,
  },
  {
    id: 'chat/privacy',
    section: 'privacy',
    scenes: [VelaScene.Chat],
    evaluate: (_ctx, t) => ({
      id: 'chat-privacy',
      icon: <Lock />,
      title: t('card.chat_privacy.title'),
      description: t('card.chat_privacy.body'),
    }),
  },
];
